import React from "react";

export const InputText = ({
  label,
  type,
  name,
  mandatory,
  area,
  setFields,
  fields,
}) => {
  return !area && type != "textarea" ? (
    <label className="form-col js-form-label" htmlFor={name}>
      <p className="js-form-text">{label}</p>
      <input
        id={name}
        name={name}
        type={type}
        required={mandatory}
        value={fields[name]}
        onChange={(e) => {
          setFields({ ...fields, [name]: e.target.value });
        }}
      />
    </label>
  ) : (
    <>
      <label className="js-form-label" htmlFor={name}>
        <p className="mb-2">{label}</p>
        <textarea
          onChange={(e) => {
            setFields({ ...fields, [name]: e.target.value });
          }}
          name={name}
          required={mandatory}
          value={fields[name]}
        ></textarea>
      </label>
    </>
  );
};
